import { Outlet } from "@tanstack/react-router";
import { Header } from "./Header";

export function Layout() {
  return (
    <div className="min-h-dvh bg-[var(--color-bg-page)] text-[var(--color-text-primary)]">
      <Header />
      <main className="mx-auto flex max-w-[62rem] flex-col gap-6 px-4 py-6 lg:flex-row lg:items-start lg:justify-center">
        <Outlet />
      </main>
    </div>
  );
}
